import React, { useRef, useEffect } from 'react';
import styled from 'styled-components';
import { forwardRef } from '../../system/forwardRef.es.js';
import '../../utils/assertions.es.js';
import { mergeRefs } from '../../utils/refs.es.js';
import '../../utils/responsive.es.js';
import '../../utils/scrollIntoView.es.js';
import { radius, themeMode, color } from '../../utils/theme.es.js';
import '../../utils/useEnhancedEffect.es.js';
import 'react-is';
import { Box } from '../../primitives/Box/Box.es.js';
import '../../primitives/Center/styled.es.js';
import '../../primitives/Group/Group.es.js';
import '../../primitives/Grid/Grid.es.js';
import '../../primitives/Level/Level.es.js';
import '../../primitives/Shelf/Shelf.es.js';
import '../../primitives/Portal/Portal.es.js';
import '../../primitives/Hidden/Hidden.es.js';
import '../../primitives/Media/Media.es.js';
import '../../primitives/Dialog/Dialog.es.js';
import '../../primitives/VisuallyHidden/VisuallyHidden.es.js';
import '../../primitives/TruncateByCharacters/TruncateByCharacters.es.js';
import '../../primitives/TruncateByLines/TruncateByLines.es.js';
import 'react-transition-group';
import '../../primitives/Popper/Popper.es.js';
import '../../primitives/DragHandle/DragHandle.es.js';
import '../../primitives/Pin/Pin.es.js';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const StyledScrollable = styled(Box)`
    overflow: auto;
    flex: 1 1 auto;
    scrollbar-gutter: stable both-edges;

    &::-webkit-scrollbar {
        width: 12px;
    }

    &::-webkit-scrollbar-track {
        background-color: transparent;
    }

    &::-webkit-scrollbar-thumb {
        border: 2px solid transparent;
        border-radius: ${radius("round")};
        background-color: ${themeMode({ light: color("neutral.1000", 0.25), dark: color("neutral.0", 0.5) })};
        background-clip: content-box;
    }

    /* This is a check for Chrome since other browsers can support overflow: overlay but reverts it to auto */
    @supports (scrollbar-gutter: stable) {
        overflow: overlay;

        &::-webkit-scrollbar-thumb {
            background-color: transparent;
        }

        &:hover {
            &::-webkit-scrollbar-thumb {
                background-color: ${themeMode({ light: color("neutral.1000", 0.25), dark: color("neutral.0", 0.5) })};
            }
        }
    }

    scrollbar-color: rgba(255, 255, 255, 0) rgba(255, 255, 255, 0);
    scrollbar-width: thin;
    scrollbar-color: ${themeMode({ light: color("neutral.1000", 0.25), dark: color("neutral.0", 0.5) })} transparent;
    transition: scrollbar-color 100ms ease-in;
`;
const Scrollable = forwardRef((props, ref) => {
  const _a = props, { children, onScroll } = _a, rest = __objRest(_a, ["children", "onScroll"]);
  const scrollableNodeRef = useRef();
  useEffect(() => {
    const scrollableNode = scrollableNodeRef.current;
    if (!scrollableNode) {
      return;
    }
    const handleScroll = (e) => onScroll == null ? void 0 : onScroll(e);
    scrollableNode.addEventListener("scroll", handleScroll);
    return () => {
      if (scrollableNode) {
        scrollableNode.removeEventListener("scroll", handleScroll);
      }
    };
  }, [onScroll, scrollableNodeRef]);
  return /* @__PURE__ */ React.createElement(StyledScrollable, __spreadValues({
    ref: mergeRefs(ref, scrollableNodeRef)
  }, rest), children);
});
Scrollable.displayName = "Scrollable";

export { Scrollable };
//# sourceMappingURL=Scrollable.es.js.map
